import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import initialInternalControlsState from './initialState';
import { IInternalControlsState } from './types';

const internalControlsSlice = createSlice({
  name: 'internal_controls',
  initialState: initialInternalControlsState(),
  reducers: {
    set_loading(state: IInternalControlsState) {
      state.loading = true;
    },
    set_draw_table(
      state: IInternalControlsState,
      action: PayloadAction<boolean>
    ) {
      state.drawTable = action.payload;
      state.error = false;
      state.loading = false;
    },
    set_selected_entity_id(
      state: IInternalControlsState,
      action: PayloadAction<number | undefined>
    ) {
      state.selectedEntityId = action.payload;
    },
    set_save_disabled(
      state: IInternalControlsState,
      action: PayloadAction<boolean>
    ) {
      state.saveDisabled = action.payload;
    },
    set_has_changes(
      state: IInternalControlsState,
      action: PayloadAction<boolean>
    ) {
      state.hasChanges = action.payload;
      state.saveDisabled = !action.payload;
    }
  }
});

export default internalControlsSlice;
